import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Tooltip} from "../../tooltip/tooltip";
import {OddsTooltipContent} from "./odds-tooltip.content";
import {TOOLTIP_PLACEMENT} from "../../tooltip/tooltip-consts";
import {RateOptionViewModel} from "../../../../domain/common/odds/rate-option/models/rate-option.view-model";
import {BookmakerViewModel} from "../../../../domain/common/bookmaker/models/bookmaker-view-model";

export class OddsTooltipProps extends BaseProps {
  rate: RateOptionViewModel;
  bookmaker: BookmakerViewModel;
  onClick: Function;
  onShow: Function;
  className: String;
  disable: Boolean;
  isRtl: Boolean;
}

export const OddsTooltip = ({
                              option,
                              controller,
                              bookieHrefModel,
                              betsImpressionParams,
                              bookmaker,
                              onClick,
                              onShow,
                              className,
                              disable,
                              showOriginalOdds,
                              children
                            }: OddsTooltipProps) => {
  const oddsTooltipProps = {
    option,
    controller,
    bookmaker,
    bookieHrefModel,
    betsImpressionParams,
    showBookieLogo: true,
    showOriginalOdds,
    onClick,
  }

  const tooltipProps = {
    content: <OddsTooltipContent {...oddsTooltipProps}/>,
    placement: TOOLTIP_PLACEMENT.bottom,
    interactive: true,
    onShow: () => onShow && onShow(),
    className: className,
    disable: disable,
  }

  return <Tooltip {...tooltipProps}>{children}</Tooltip>
};
